import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import Navbar from '../components/Layouts/Navbar'
import HeroBanner from '../components/Common/HeroBanner';
import DButton from '../components/elements/DButton';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import Head from 'next/head';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const CanonicalTag = dynamic(() => import('../components/Layouts/CanonicalTag', { ssr: false }));
const ListingCard = dynamic(() => import('../components/events/ListingCard', { ssr: false }));
import axios from 'axios';
import { useGetItemsQuery } from '../components/Store/Features/CommonAPI'

const Events = () => {

    const { data: eventData, isLoading, isError } = useGetItemsQuery('/event/event-list');

    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)


    useEffect(() => {
        const onScroll = () => setScrolled(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        if (scrolled > 30) {
            setScrolledStatus(true)
        }
    }, [scrolled])



    return (
        <>


            <Navbar />
            <>
                <div>
                    <HeroBanner
                        background={process.env.IMG_CDN + "img/banner/event-banner.png"}
                        title={<>Global Conferences and Events</>}
                        description={<>Schedule a meeting with us and solidify your business prospects</>}
                    />
                </div>

                <Breadcrumb />
                <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4">
                    {
                        isLoading ? <><div className="flex col-span-12 justify-center items-center min-h-screen">
                            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
                        </div>
                        </> : <ListingCard data={eventData ? eventData : []} />
                    }

                </div>
            </>
            {scrolledStatus && <>
                <Footer />
            </>}

        </>
    )
}

Events.getInitialProps = async (NextPageContext) => {
    const slugData = NextPageContext.pathname
    try {
        const response = await axios.get(process.env.API_URL + '/meta' + slugData);
        return {
            title: (response?.data.meta_title) ? response?.data.meta_title : "Events | DelveInsight",
            description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        }
    } catch (error) {
        console.error('Error fetching data:', error.message);
        return {
            title: "Events | DelveInsight",
            description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        };
    }
}

export default Events;